import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const InvoiceGochiHistoryTableHead = enhance(
  ({ order, orderBy, onRequestSort }) => {
    return (
      <TableHead>
        <TableRow>
          <TableCell sortDirection={orderBy === 'monthConfirm' ? order : false}>
            <TableSortLabel
              active={orderBy === 'monthConfirm'}
              direction={order}
              onClick={() => {
                onRequestSort('monthConfirm');
              }}
            >
              請求の対象月
            </TableSortLabel>
          </TableCell>
          <TableCell
            sortDirection={orderBy === 'totalTransferAmount' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'totalTransferAmount'}
              direction={order}
              onClick={() => {
                onRequestSort('totalTransferAmount');
              }}
            >
              合計金額
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'createdAt' ? order : false}>
            <TableSortLabel
              active={orderBy === 'createdAt'}
              direction={order}
              onClick={() => {
                onRequestSort('createdAt');
              }}
            >
              確定日時
            </TableSortLabel>
          </TableCell>
        </TableRow>
      </TableHead>
    );
  }
);

export default withStyles(styles)(InvoiceGochiHistoryTableHead);
